import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import renderDateMessage from "../utils/render-date-message";
import { GeneralFieldController } from "./general-field-controller";

export class DiagnosisDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return super
			.createValidationRule(initialData, translation)
			.required(({ path }) => renderDateMessage(path, translation))
			.max(new Date(), translation("cannot-be-greater-than-today"));
	}

	override useControlProps(): FlexControlProps {
		return {
			cannotBeFuture: true
		};
	}
}
